import React from 'react';
import classNames from 'classnames/bind';
import styles from './Icon.module.scss';

const cx = classNames.bind(styles);

function Icon({ classArray = [''], className = '', text = '', style = null }) {
	return (
		<span
			className={cx('uiico', className, classArray)}
			style={style}
		>
			{text}
		</span>
	);
}

export default Icon;
